/**
 * De onde veio o número de eixos, ou por que ele não veio (0026). "—" sozinho foi lido como
 * "o modelo de eixos não funciona" (cronograma, tarefa 2), quando quase sempre o serviço de
 * visão tinha dito o motivo: foto de frente, vista oblíqua, nenhuma roda de lado.
 */
export function motivoDosEixos(
  vistas: {
    vista: string;
    eixos: number | null;
    eixos_observacao?: string | null;
  }[],
  eixos: number | null,
): string | null {
  if (eixos != null) {
    const origem =
      vistas.find((v) => v.eixos === eixos)?.eixos_observacao ?? "";
    if (/rodas/i.test(origem)) return "contado pelas rodas, confira na imagem";
    if (/marcas/i.test(origem)) return "pelas marcas do equipamento";
    return null;
  }
  // A lateral primeiro: é de onde os eixos saem, e o motivo dela é o que interessa.
  const ordenadas = [...vistas].sort(
    (a, b) =>
      Number(!/^(lateral|camera-l)/.test(a.vista)) -
      Number(!/^(lateral|camera-l)/.test(b.vista)),
  );
  const motivo = ordenadas.find((v) => v.eixos_observacao)?.eixos_observacao;
  if (!motivo) return vistas.length ? "nenhuma vista permitiu contar" : null;
  // Foto de frente, de trás ou na diagonal (Gisele, 25/09: "a IA de eixos não funciona nas
  // imagens do pórtico"). A contagem só é feita com o veículo de lado — de propósito, porque
  // na diagonal o detector sem treino errou mais do que acertou (docs/14, §6) —, e a tela diz
  // isso em português, com o que fazer, em vez do motivo técnico do serviço. Medido de novo
  // em 29/09 com as rodas procuradas no recorte ampliado do veículo: fora da amostra, 5
  // certos e 2 errados em 26 fotos na diagonal — ainda não é número para sugerir.
  if (/vista lateral|visto de lado|obl[ií]qua/i.test(motivo))
    return "na diagonal a IA ainda não conta com segurança — conte as rodas de um lado na foto e informe os eixos";
  return motivo
    .replace(/\s*Contagem por modelo é a fase 2\.?/i, "")
    .replace(/\s*Revisão humana\.?/i, "")
    .trim();
}
